import { Navigate, useParams } from '@exam-center/router';

export default function AdminExamCoursePage() {
  const { examCourseCode } = useParams('/admin/exam-courses/:examCourseCode');

  return (
    <Navigate
      to='/admin/exam-courses/:examCourseCode/details'
      params={{ examCourseCode }}
      replace
    />
  );
}
